export default __webpack_public_path__ + "static/media/thumbnail.53da027c.webp";